import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  button: {
    [theme.breakpoints.up('xs')]: {
      paddingLeft: 0,
      paddingRight: 0
    }
  },
  buttonContainer: {
    [theme.breakpoints.up('xs')]: {
      paddingLeft: 0,
      paddingRight: '10px!important'
    }
  },
  skeleton: {
    width: '100%'
  }
}))
export default useStyles
